const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

export const fetchPayouts = async (accessToken, status) => {
  let url = `${API_URL}/payouts/admin/pending`;
  if (status) url += `?status=${status}`;
  const res = await fetch(url, {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) throw new Error(`Failed to fetch payouts: ${res.status}`);
  return res.json();
};

export const fetchManufacturerAcceptances = async (accessToken) => {
  const res = await fetch(`${API_URL}/payouts/admin/manufacturer-acceptances`, {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) throw new Error(`Failed to fetch manufacturer acceptances: ${res.status}`);
  return res.json();
};

export const fetchManuLeads = async (accessToken, status) => {
  let url = `${API_URL}/admin/manu-leads`;
  if (status) url += `?status=${status}`;
  const res = await fetch(url, {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) throw new Error(`Failed to fetch leads: ${res.status}`);
  return res.json();
};

export const approveManuLead = async (accessToken, leadId) => {
  const res = await fetch(`${API_URL}/admin/manu-leads/${leadId}/approve`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const rejectManuLead = async (accessToken, leadId) => {
  const res = await fetch(`${API_URL}/admin/manu-leads/${leadId}/reject`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const recordPayout = async (accessToken, body) => {
  const res = await fetch(`${API_URL}/payouts/admin/record`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const fetchBlanksOrders = async (accessToken, status) => {
  let url = `${API_URL}/admin/blanks`;
  if (status) url += `?status=${status}`;
  const res = await fetch(url, {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) throw new Error(`Failed to fetch blanks orders: ${res.status}`);
  return res.json();
};

export const fulfillBlanksOrder = async (accessToken, body) => {
  const res = await fetch(`${API_URL}/admin/blanks/fulfill`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const fetchDisputes = async (accessToken, status) => {
  let url = `${API_URL}/admin/disputes`;
  if (status) url += `?status=${status}`;
  const res = await fetch(url, {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) throw new Error(`Failed to fetch disputes: ${res.status}`);
  return res.json();
};

export const updateDisputeStatus = async (accessToken, { disputeId, status, adminNotes }) => {
  const res = await fetch(`${API_URL}/admin/disputes/${disputeId}/status`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ status, adminNotes })
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const resolveDispute = async (accessToken, { disputeId, resolutionType, resolutionAmount, adminNotes, finalStatus }) => {
  const res = await fetch(`${API_URL}/admin/disputes/${disputeId}/resolve`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ resolutionType, resolutionAmount, adminNotes, finalStatus })
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const fetchBroadcastOptions = async (accessToken) => {
  const res = await fetch(`${API_URL}/admin/broadcast/options`, {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) throw new Error(`Failed to fetch broadcast options: ${res.status}`);
  return res.json();
};

export const previewBroadcast = async (accessToken, audience) => {
  const res = await fetch(`${API_URL}/admin/broadcast/preview`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ audience })
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const sendBroadcast = async (accessToken, body) => {
  const res = await fetch(`${API_URL}/admin/broadcast/send`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Failed: ${res.status}`);
  }
  return res.json();
};

export const fetchBroadcastHistory = async (accessToken) => {
  const res = await fetch(`${API_URL}/admin/broadcast/history`, {
    headers: { 'Authorization': `Bearer ${accessToken}` }
  });
  if (res.status === 403) throw new Error('FORBIDDEN');
  if (!res.ok) throw new Error(`Failed to fetch broadcast history: ${res.status}`);
  return res.json();
};
